// extracted by mini-css-extract-plugin
export default {"bigCard":"bigCard_bigCard__azZvR"};